module.exports = "<mat-card>{{message}}</mat-card>\r\n\r\n"